// import React from 'react';
// // fields: [{ label, key, readOnly }], data: object, onClose: fn, onSave: fn, title: string
// function EditModal({ title, fields, data, onClose, onSave }) {
//     return (
//         <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
//             <div style={{ background: '#fff', borderRadius: 8, padding: 32, minWidth: 320, boxShadow: '0 2px 12px rgba(0,0,0,0.12)' }}>
//                 <h3 style={{ marginBottom: 16 }}>{title}</h3>
//                 <form>
//                     {fields.map((field) => (
//                         <div key={field.key} style={{ marginBottom: 12 }}>
//                             <label>{field.label}:</label>
//                             <input
//                                 type="text"
//                                 value={
//                                     Array.isArray(data[field.key])
//                                         ? data[field.key].join(', ')
//                                         : data[field.key] ?? ''
//                                 }
//                                 readOnly={field.readOnly}
//                                 style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
//                             />
//                         </div>
//                     ))}
//                 </form>
//                 <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 16 }}>
//                     <button onClick={onClose} style={{ padding: '8px 24px', borderRadius: 4, border: '1px solid #ccc', background: '#eee', cursor: 'pointer' }}>Cancel</button>
//                     <button onClick={onSave} style={{ padding: '8px 24px', borderRadius: 4, border: 'none', background: '#E30613', color: '#fff', cursor: 'pointer' }}>Save</button>
//                 </div>
//             </div>
//         </div>
//     );
// }
// export default EditModal

import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ImageResize from 'quill-image-resize-module-react';

Quill.register('modules/imageResize', ImageResize);
// fields: [{ label, key, readOnly, type }], data: object, onClose: fn, onSave: fn, title: string
// function EditModal({ title, fields, data, onClose, onSave }) {
//     const [formData, setFormData] = useState({});
//     const [isSaving, setIsSaving] = useState(false);

//     useEffect(() => {
//         const initialData = {};
//         if (fields && Array.isArray(fields)) {
//             fields.forEach(field => {
//                 initialData[field.key] = Array.isArray(data?.[field.key])
//                     ? data[field.key].join(', ')
//                     : data?.[field.key] ?? '';
//             });
//         }
//         setFormData(initialData);
//     }, [fields, data]);

//     const handleChange = (key, value) => {
//         setFormData(prev => ({ ...prev, [key]: value }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setIsSaving(true);
//         await onSave(formData);
//         setIsSaving(false);
//     };

//     const handleBackdropClick = (e) => {
//         if (e.target === e.currentTarget) {
//             onClose();
//         }
//     };

//     return (
//         <div 
//             onClick={handleBackdropClick}
//             className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999] p-4 animate-fade-in"
//         >
//             <style>{`
//                 @keyframes fade-in {
//                     from { opacity: 0; }
//                     to { opacity: 1; }
//                 }
//                 @keyframes slide-up {
//                     from { 
//                         opacity: 0;
//                         transform: translateY(20px);
//                     }
//                     to { 
//                         opacity: 1;
//                         transform: translateY(0);
//                     }
//                 }
//                 .animate-fade-in {
//                     animation: fade-in 0.2s ease-out;
//                 }
//                 .animate-slide-up {
//                     animation: slide-up 0.3s ease-out;
//                 }
//             `}</style>
//             <div 
//                 className="bg-white rounded-xl w-full max-w-lg max-h-[90vh] overflow-hidden shadow-2xl flex flex-col animate-slide-up"
//             >
//                 {/* Header */}
//                 <div className="px-8 py-6 border-b border-gray-200 flex justify-between items-center">
//                     <h3 className="text-xl font-semibold text-gray-900 m-0">{title}</h3>
//                     <button
//                         onClick={onClose}
//                         className="w-8 h-8 rounded-md flex items-center justify-center p-0 border-0 bg-transparent hover:bg-gray-100 transition-all duration-200 hover:rotate-90"
//                     >
//                         <X size={20} className="text-gray-600" />
//                     </button>
//                 </div>

//                 {/* Form Content */}
//                 <div className="flex-1 overflow-auto px-8 py-6">
//                     {fields && fields.length > 0 ? (
//                         fields.map((field) => (
//                             <div key={field.key} className="mb-5">
//                                 <label className="block mb-2 text-sm font-medium text-gray-700">
//                                     {field.label}
//                                     {field.readOnly && (
//                                         <span className="ml-2 text-xs text-gray-500 font-normal">
//                                             (read-only)
//                                         </span>
//                                     )}
//                                 </label>
//                                 <input
//                                     type={field.type || "text"}
//                                     value={formData[field.key] || ''}
//                                     onChange={(e) => handleChange(field.key, e.target.value)}
//                                     disabled={field.readOnly}
//                                     className="w-full px-3.5 py-2.5 rounded-lg border-2 border-gray-300 text-sm focus:outline-none focus:border-red-600 focus:ring-4 focus:ring-red-600/10 disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200"
//                                 />
//                             </div>
//                         ))
//                     ) : (
//                         <div className="text-center py-5 text-gray-500">
//                             No fields to display
//                         </div>
//                     )}
//                 </div>

//                 {/* Footer */}
//                 <div className="px-8 py-5 border-t border-gray-200 bg-gray-50 flex justify-end gap-3">
//                     <button 
//                         type="button"
//                         onClick={onClose} 
//                         disabled={isSaving}
//                         className="px-6 py-2.5 rounded-lg border-2 border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 hover:-translate-y-0.5 hover:shadow-lg disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none transition-all duration-200 active:translate-y-0"
//                     >
//                         Cancel
//                     </button>
//                     <button 
//                         type="button"
//                         onClick={handleSubmit}
//                         disabled={isSaving}
//                         className="px-7 py-2.5 rounded-lg border-0 bg-gradient-to-br from-red-600 to-red-700 text-sm font-medium text-white hover:from-red-700 hover:to-red-800 hover:-translate-y-0.5 hover:shadow-lg disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none transition-all duration-200 active:translate-y-0"
//                     >
//                         {isSaving ? 'Saving...' : 'Save Changes'}
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// }

function EditModal({ title, fields, data, onClose, onSave, errorMessage = '' }) {
    const [formData, setFormData] = useState({});
    const [isSaving, setIsSaving] = useState(false);
    const quillModules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ color: [] }, { background: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ align: [] }],
            ['link', 'image', 'clean'],
        ],
        imageResize: {
            modules: ['Resize', 'DisplaySize'],
        },
    };

    const quillFormats = [
        'header',
        'bold',
        'italic',
        'underline',
        'strike',
        'color',
        'background',
        'list',
        'bullet',
        'align',
        'link',
        'image',
    ];


    // Helper to extract variables from content
    const extractVariables = (text) => {
        const regex = /{{(.*?)}}/g;
        const matches = [];
        let match;
        while ((match = regex.exec(text)) !== null) {
            matches.push(match[1].trim());
        }
        return [...new Set(matches)];
    };

    // Track variables in state
    const [detectedVariables, setDetectedVariables] = useState([]);

    useEffect(() => {
        const initialData = {};
        if (fields && Array.isArray(fields)) {
            fields.forEach(field => {
                if (field.type === 'multiselect') {
                    const rawValue = data?.[field.key];

                    if (Array.isArray(rawValue)) {
                        initialData[field.key] = rawValue;
                    } else if (typeof rawValue === 'string') {
                        initialData[field.key] = rawValue
                            .split(',')
                            .map((value) => value.trim())
                            .filter(Boolean);
                    } else {
                        initialData[field.key] = [];
                    }
                } else {
                    initialData[field.key] = Array.isArray(data?.[field.key])
                        ? data[field.key].join(', ')
                        : data?.[field.key] ?? '';
                }
            });
        }
        // Extract variables from content if present
        let content = initialData.content || data?.content || '';
        const vars = extractVariables(content);
        setDetectedVariables(vars);
        // Initialize variable values
        if (vars.length > 0) {
            vars.forEach((v) => {
                if (initialData[v] === undefined) {
                    initialData[v] = (data?.variableValues && data.variableValues[v]) || '';
                }
            });
        }
        setFormData(initialData);
    }, [fields, data]);

    // Watch for content changes and update detected variables
    useEffect(() => {
        const content = formData.content || '';
        const vars = extractVariables(content);
        setDetectedVariables(vars);
        // Add new variable keys to formData if missing
        if (vars.length > 0) {
            setFormData(prev => {
                const updated = { ...prev };
                vars.forEach((v) => {
                    if (updated[v] === undefined) updated[v] = '';
                });
                // Remove deleted variables
                Object.keys(updated).forEach((key) => {
                    if (!vars.includes(key) && key !== 'content' && !fields.some(f => f.key === key)) {
                        delete updated[key];
                    }
                });
                return updated;
            });
        }
    }, [formData.content, fields]);

    const handleChange = (key, value) => {
        setFormData(prev => ({ ...prev, [key]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        await onSave(formData);
        setIsSaving(false);
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div 
            onClick={handleBackdropClick}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999] p-4 animate-fade-in"
        >
            <style>{`
                @keyframes fade-in {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                @keyframes slide-up {
                    from { 
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to { 
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                .animate-fade-in {
                    animation: fade-in 0.2s ease-out;
                }
                .animate-slide-up {
                    animation: slide-up 0.3s ease-out;
                }
                .edit-modal-description-editor .ql-container {
                    min-height: 220px;
                }
                .edit-modal-description-editor .ql-editor {
                    min-height: 180px;
                }
            `}</style>
            <div 
                className="bg-white rounded-xl w-full max-w-4xl max-h-[90vh] overflow-hidden shadow-2xl flex flex-col animate-slide-up"
            >
                {/* Header */}
                <div className="px-8 py-6 border-b border-gray-200 flex justify-between items-center">
                    <h3 className="text-xl font-semibold text-gray-900 m-0">{title}</h3>
                    <button
                        onClick={onClose}
                        className="w-8 h-8 rounded-md flex items-center justify-center p-0 border-0 bg-transparent hover:bg-gray-100 transition-all duration-200 hover:rotate-90"
                    >
                        <X size={20} className="text-gray-600" />
                    </button>
                </div>

                {/* Form Content */}
                <div className="flex-1 overflow-auto px-8 py-6">
                    {fields && fields.length > 0 ? (
                        fields.map((field) => (
                            <div key={field.key} className="mb-2">
                                <label className="block mb-2 text-sm font-medium text-gray-700">
                                    {field.label}
                                </label>
                                {field.type === 'multiselect' ? (
                                    <>
                                        {/* Selected chips */}
                                        <div className="flex flex-wrap gap-2 mb-2">
                                            {(Array.isArray(formData[field.key]) ? formData[field.key] : []).map((selected, idx) => {
                                                const optionObj = field.options?.find(opt => (typeof opt === 'object' ? opt.value : opt) === selected);
                                                return (
                                                    <span key={selected} className="inline-flex items-center px-3 py-1 rounded-full bg-red-100 text-red-700 text-xs font-medium">
                                                        {optionObj ? (optionObj.label || optionObj.value) : selected}
                                                        <button
                                                            type="button"
                                                            className="ml-2 text-red-500 hover:text-red-700 focus:outline-none"
                                                            onClick={() => {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    [field.key]: prev[field.key].filter((v) => v !== selected)
                                                                }));
                                                            }}
                                                            aria-label={`Remove ${selected}`}
                                                        >
                                                            ×
                                                        </button>
                                                    </span>
                                                );
                                            })}
                                        </div>
                                        {/* Dropdown for remaining options */}
                                        <select
                                            value=""
                                            onChange={e => {
                                                const value = e.target.value;
                                                if (!value) return;
                                                setFormData(prev => ({
                                                    ...prev,
                                                    [field.key]: Array.isArray(prev[field.key]) ? [...prev[field.key], value] : [value]
                                                }));
                                            }}
                                            disabled={field.readOnly}
                                            className="w-full px-3.5 py-2.5 rounded-lg border-2 border-gray-300 text-sm disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200 bg-white"
                                        >
                                            <option value="">Select options</option>
                                            {field.options?.filter(option => {
                                                const val = typeof option === 'object' ? option.value : option;
                                                return !(Array.isArray(formData[field.key]) && formData[field.key].includes(val));
                                            }).map(option => (
                                                <option key={typeof option === 'object' ? option.value : option} value={typeof option === 'object' ? option.value : option}>
                                                    {typeof option === 'object' ? option.label : option}
                                                </option>
                                            ))}
                                        </select>
                                    </>
                                ) : field.type === 'select' ? (
                                    <select
                                        value={formData[field.key] || ''}
                                        onChange={(e) => handleChange(field.key, e.target.value)}
                                        disabled={field.readOnly}
                                        className="w-full px-3.5 py-2.5 rounded-lg border-2 border-gray-300 text-sm disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200 bg-white"
                                    >
                                        <option value="">Select an option</option>
                                        {field.options?.map((option) => (
                                            <option 
                                                key={typeof option === 'object' ? option.value : option} 
                                                value={typeof option === 'object' ? option.value : option}
                                            >
                                                {typeof option === 'object' ? option.label : option}
                                            </option>
                                        ))}
                                    </select>
                                ) : field.type === 'textarea' ? (
                                    <textarea
                                        value={formData[field.key] || ''}
                                        onChange={(e) => handleChange(field.key, e.target.value)}
                                        disabled={field.readOnly}
                                        rows={field.rows || 3}
                                        className="w-full px-3.5 py-2.5 rounded-lg border-2 border-gray-300 text-sm  disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200 resize-y"
                                    />
                                ) : field.type === 'quill' ? (
                                    <ReactQuill
                                        className="edit-modal-description-editor"
                                        value={formData[field.key] || ''}
                                        onChange={(value) => handleChange(field.key, value)}
                                        readOnly={field.readOnly}
                                        modules={quillModules}
                                        formats={quillFormats}
                                        placeholder={field.placeholder || 'Enter description'}
                                    />
                                ) : (
                                    <input
                                        type={field.type || "text"}
                                        value={formData[field.key] || ''}
                                        onChange={(e) => handleChange(field.key, e.target.value)}
                                        disabled={field.readOnly}
                                        className={
                                            field.type === 'date' || field.key === 'name'
                                                ? "w-full px-3.5 py-2.5 rounded-lg border-2 border-gray-300 text-sm disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200"
                                                : "w-full px-3.5 py-2.5 rounded-lg border-2 border-gray-300 text-sm disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200"
                                        }
                                    />
                                )}
                            </div>
                        ))
                    ) : (
                        <div className="text-center py-5 text-gray-500">
                            No fields to display
                        </div>
                    )}

                    {/* Detected Variables Section */}
                    {detectedVariables && detectedVariables.length > 0 && (
                        <div className="mt-6">
                            <label className="block mb-2 text-base font-semibold text-gray-800">Detected Variables:</label>
                            <div className="flex flex-wrap gap-4">
                                {detectedVariables.map((varName) => (
                                    <div key={varName} className="flex-1 min-w-[180px]">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">{varName}</label>
                                        <input
                                            type="text"
                                            value={formData[varName] || ''}
                                            onChange={(e) => handleChange(varName, e.target.value)}
                                            placeholder={`Enter value for ${varName}`}
                                            className="w-full px-3.5 py-2.5 rounded-lg border-2 border-gray-300 text-sm  disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200"
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                {/* Footer */}
                {errorMessage ? (
                    <div className="px-8 pt-3">
                        <p className="text-sm text-red-600">{errorMessage}</p>
                    </div>
                ) : null}

                <div className="px-8 py-3 border-t border-gray-200 bg-gray-50 flex justify-end gap-3">
                    <button 
                        type="button"
                        onClick={onClose} 
                        disabled={isSaving}
                        className="px-6 py-2.5 rounded-lg border-2 border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 hover:-translate-y-0.5 hover:shadow-lg disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none transition-all duration-200 active:translate-y-0"
                    >
                        Cancel
                    </button>
                    <button 
                        type="button"
                        onClick={handleSubmit}
                        disabled={isSaving}
                        className="px-7 py-2.5 rounded-lg border-0 bg-gradient-to-br from-red-600 to-red-700 text-sm font-medium text-white hover:from-red-700 hover:to-red-800 hover:-translate-y-0.5 hover:shadow-lg disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none transition-all duration-200 active:translate-y-0"
                    >
                        {isSaving ? 'Saving...' : 'Save Changes'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default EditModal;